import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { getItemUrlFromSlug } from '@/utils/urls';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { ItemSummary } from '@/types/item/ItemSummary';
import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';

export const TitleComponent = createInfo<ItemSummary & { position: number }>({
    className: 'line-clamp-0',
    useText: ({ itemId, position, slugWithLocation, title }) => {
        const { onNavigateInitiated } = useItemCardNavigation(itemId);
        return (
            <SubtleMonochromeLink
                aria-label={title}
                className="line-clamp-2 group-[.image-hover]:text-link-hover group-[.image-hover]:underline"
                href={getItemUrlFromSlug(itemId, slugWithLocation)}
                onClick={() => {
                    onNavigateInitiated(ItemCardNavigationTrigger.TitleClick, { position });
                }}
                title={title}
            >
                {title}
            </SubtleMonochromeLink>
        );
    },
});
